import { render, staticRenderFns } from "./popup-confirm.vue?vue&type=template&id=19b20bbe&scoped=true"
import script from "./popup-confirm.vue?vue&type=script&lang=js"
export * from "./popup-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b20bbe",
  null
  
)

export default component.exports